import MuiSelect from "@mui/material/Select";
import React from "react";
import wrappable from "utils/wrappable";

const Select = wrappable((props) => {
  return <MuiSelect {...props} />;
});

export default Select;
